import { observer } from "mobx-react";
import React, { useEffect, useMemo, useState } from "react";
import ModalContent from "src/Shared/Components/ModalContent/ModalContent";
import { useModal, useStore } from "src/Shared/Hooks";
import { fields } from "./fields";
import { getFormValidation } from "src/Shared/Components";
import { IGridFormControlProps } from "src/Shared/Interfaces/IGridFormControlProps.interface";
import { EDITOR_TYPES } from "src/Shared/Enums";
import GridFormControl from "src/Shared/Components/GridFormControl/GridFormControl";
import { CommonService, ToastService } from "src/Shared/Services";
import { ILinkImperansCompany } from "../../Interfaces/ILinkImperansCompany";
import CompanyService from "../../Services/Company.service";
import { AxiosError } from "axios";
import { finalize } from "rxjs";
import { ISelectOption } from "src/Shared/Interfaces";
type Props = {
  companyRowID: string;
  companyIntergrationDeatail?: ISelectOption | null;
  title: string;
};

const ImperansCompanyIntegration: React.FC<Props> = ({
  companyRowID,
  companyIntergrationDeatail,
  title,
}) => {
  const {
    rootStore: {
      companyStore: { getCompany },
    },
  } = useStore();

  const modal = useModal();

  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (companyIntergrationDeatail) {
      const imperansCompanyField = getField("imperansCompany");
      imperansCompanyField.set("value", companyIntergrationDeatail);
    }
  }, [companyIntergrationDeatail]);

  const companyIntergrationForm = useMemo(() => getFormValidation(fields), []);
  const getField = (key: string) => companyIntergrationForm.$(key);

  const gridProps: IGridFormControlProps = {
    row: 1,
    col: 1,
    itemResponsive: {
      lg: 12,
      sm: 12,
      md: 4,
    },
    inputControls: [
      {
        field: getField("imperansCompany"),
        fieldKey: "imperansCompany",
        type: EDITOR_TYPES.AUTO_COMPLETE_ASYNC,
        apiObservable: (search: string) =>
          CommonService.getImperansCompanies(search, 20),
        rows: 12,
        hideValueInOptions: true,
        stickyOptions: [
          {
            label: "Company does not exist in Imperans",
            value: 0,
          },
        ],
      },
    ],
    form: companyIntergrationForm,
  };

  const onSubmitForm = (): any => {
    if (!companyIntergrationForm.isValid) {
      companyIntergrationForm.showErrors();
      return;
    }
    const request: ILinkImperansCompany = {
      companyRowID: companyRowID,
      imperansCompanyID: companyIntergrationForm.values().imperansCompany.value,
    };
    setLoading(true);
    CompanyService.linkCompanyToImperans(request)
      .pipe(
        finalize(() => {
          setLoading(false);
        })
      )
      .subscribe({
        next: (response) => {
          ToastService.success(response.message);
          modal.close();
          getCompany(companyRowID);
        },
        error: (error: AxiosError) => ToastService.axiosError(error),
      });
  };

  return (
    <ModalContent
      buttonText={title}
      title={title}
      onSaveButtonClick={() => onSubmitForm()}
      btnLoading={loading}
    >
      <GridFormControl {...gridProps} />
    </ModalContent>
  );
};

export default observer(ImperansCompanyIntegration);
